export default {
    // PricePlan - header
    yearly_payment:   "Ročná platba",
    yearly_discount:  "-20% ZĽAVA",
    monthly_payment:  "Mesačná platba",
    trial_info:       "Všetky platené plány zahŕňajú 14-dňovú skúšobnú verziu zadarmo",
    try_free:         "Vyskúšať zadarmo",
    active_plan:      "Aktívny balíček",
    choose_plan:      "Zvoliť balíček",
    upsell_msg:       "Pozri sa, čo môžeš získať už od {price} denne",
    compare_plans:    "Porovnať všetky funkcie",
    your_plan:        "TVOJ BALÍK",
    prepay_discount:  "predplatiť so zľavou",
    register:         "ZAREGISTROVAŤ",

    // Plan names
    plan_free:       "Zadarmo",
    plan_profi:      "Profi",
    plan_small_team: "Malý tím",
    plan_big_team:   "Veľký tím",
    up_to:           "až",

    // Plan features
    feat_unlimited_clients:   "Neobmedzený počet klientov",
    feat_unlimited_offers:    "Neobmedzený počet ponúk",
    feat_hide_logo:           "Skryť logo DOFFERO",
    feat_custom_colors:       "Vlastné farby v dizajne",
    feat_success_stats:       "Štatistika úspešnosti ponúk",
    feat_ai_descriptions:     "AI popisy",
    feat_team_accounts:       "Účty pre kolegov a obchodný tím",
    feat_seller_stats:        "Štatistika úspešnosti predajcov",
    feat_priority_support:    "Prednostná podpora",
    feat_ai_offers:           "AI tvorba cenových ponúk (pripravujeme)",
    feat_margin:              "⁠Výpočet marže (pripravujeme)",

    // dashboard.vue
    subscription_title:    "Správa predplatného",
    subscription_subtitle: "Vyber si balíček, ktorý ti najviac vyhovuje",
    payment_success:       "Tvoja platba bola úspešná. Predplatné sa aktivuje o chvíľu.",
    payment_failed:        "Tvoja platba nebola úspešná.",
    trial_expired:         "Skúšobná doba tvojho balíčka skončila. Ak chceš obnoviť balíček, klikni na tlačidlo vedľa, alebo si vyber z balíčkov nižšie.",
    renew_plan:            "Obnoviť balíček",
    active_plan_label:     "Tvoj aktívny balíček",
    started_label:         "Začiatok",
    next_payment_label:    "Ďalšia platba",
    admin_created:         "Tvoj balíček bol vytvorený adminom",
    trial_active:          "Aktuálne máš aktivovaný balíček",
    trial_days:            "na {days} dní zadarmo, ktorý ti skončí",
    sub_cancels:           "Tvoje predplatné skončí",
    sub_active:            "Aktuálne máš aktivovaný balíček",
    sub_next_payment:      ", ďalšia platba prebehne",
    manage_subscription:   "Správa predplatného",
    subusers_info:         "Aktuálne máš {count} sub-kont. Pre správnu funkčnosť je potrebné zvoliť aspoň balíček",
    subkonto_plural:       "sub-kont",
    subkonto_singular:     "sub-konto",
    invoices_title:        "Platby a faktúry",

    // InvoiceDetails
    billing_alert:         "Prosím, skontroluj si svoje fakturačné údaje",
    billing_check:         "Skontroluj si fakturačné údaje pred platbou",
    billing_note:          "Tieto fakturačné údaje budú na faktúre po platbe",
    save_data:             "Uložiť údaje",
    continue_payment:      "Pokračovať na platbu",
    data_saved:            "Údaje boli úspešne uložené",
    section_country:            "Krajina",
    section_company:            "Spoločnosť",
    section_address:            "Adresa",
    country_search_placeholder: "Vyhľadať krajinu…",
    vat_id_cz:                  "DIČ (DPH)",
    vat_verifying:              "Overujem DIČ v registri ARES…",
    vat_valid:                  "DIČ je platné",
    vat_invalid:                "Neplatné DIČ – skontrolujte ho. Bez platného DIČ bude účtovaná DPH.",
    ares_checking:              "Overujem IČO v registri ARES…",
    ares_found_hint:           "Firma nájdená v registri ARES",
    ares_fill:                  "Doplniť údaje z ARES",
    ares_filled:               "Údaje doplnené z ARES",
    ares_not_found:            "IČO sa v registri ARES nenašlo. Skontroluj ho, prosím.",
    ares_error:                "Register ARES je momentálne nedostupný. Údaje môžeš vyplniť ručne.",
    ares_bad_ico:              "IČO musí mať 8 číslic.",

    // Country names
    country_cz: "Česká republika",
    country_at: "Rakúsko",
    country_pl: "Poľsko",
    country_hu: "Maďarsko",
    country_hr: "Chorvátsko",
    country_me: "Čierna Hora",
    country_mk: "Severné Macedónsko",
    country_lv: "Lotyšsko",
    country_ee: "Estónsko",
    country_fi: "Fínsko",
    country_se: "Švédsko",
    country_no: "Nórsko",
    country_dk: "Dánsko",
    country_ie: "Írsko",
    country_gb: "Veľká Británia",
    country_fr: "Francúzsko",
    country_es: "Španielsko",
    country_gr: "Grécko",
    country_ch: "Švajčiarsko",
    country_li: "Lichtenštajnsko",
    country_sm: "San Maríno",
    country_va: "Vatikán",
    country_us: "Spojené štáty americké",
    country_br: "Brazília",
    country_ar: "Argentína",
    country_cl: "Čile",
    country_au: "Austrália",
    country_nz: "Nový Zéland",
    country_kr: "Južná Kórea",
    country_cn: "Čína",
    country_id: "Indonézia",
    country_ph: "Filipíny",
    country_ae: "Spojené arabské emiráty",
    country_sa: "Saudská Arábia",
    country_za: "Južná Afrika",
    country_ng: "Nigéria",
    country_ke: "Keňa",
    country_other: "Iné",

    // stripe/dashboard remaining
    invoice_date_col:    "Dátum",
    invoice_num_col:     "Číslo faktúry",
    no_invoices:         "Aktuálne nemáš žiadne platby a faktúry",
    cancel_sub:          "Zrušiť predplatné",
    renew_sub:           "Obnoviť predplatné",
    change_billing:      "Zmeniť údaje na faktúre",
    period_monthly:      "Mesačne",
    period_yearly:       "Ročne",

    // SubscriptionOfferAlert
    alert_close:         "Zatvoriť",
    alert_manage_sub:    "Spravovať predplatné",
    alert_renew:         "Obnoviť",
    alert_offers_counter:"vytvorených ponúk",
    alert_upgrade_title: "Tvoj účet vyžaduje vyšší balíček",
    alert_upgrade_text:  "Od 1. mája 2025 prechádza DOFFERO na nový platený model. Aby si mohol/la pracovať so všetkými ponukami, vyber si vyšší balíček. <a href='/cennik'>Viac info</a>",
    alert_main_upgrade:  "Hlavný účet vyžaduje vyšší balíček",
    alert_trial_ended:   "Tvoje skúšobné obdobie skončilo",
    alert_trial_text:    "Tvoja skúšobná verzia DOFFERO® práve skončila. Veríme, že si si ju užil/a a zistil/a, ako ti môže pomôcť s tvorbou cenových ponúk. <br><br> Ak chceš pokračovať s plným prístupom, vyber si jeden z balíkov a aktivuj si predplatné.",

    // PricePlan remaining
    plan_free_clients:   " ⁠Maximálne 3 klienti",
    plan_free_offers:    "Maximálne 3 vytvorené ponuky",
    plan_small_team_acc: "Až 5 účtov pre kolegov a obchodný tím",
    plan_big_team_acc:   "Až 20 účtov pre kolegov a obchodný tím",
    feat_unlimited_offers2: "Neobmedzený počet ponuk",
    sub_status_cancelled:"Zrušené",
};